import { TextField } from '@mui/material';
import React from 'react';

interface VideoUploadTitleFieldsProps {
  title: string;
  onTitleChange: (value: string) => void;
  description: string;
  onDescriptionChange: (value: string) => void;
  disabled: boolean;
}

/** Viewer-facing title + description fields for a video library upload. */
export default function VideoUploadTitleFields({
  title,
  onTitleChange,
  description,
  onDescriptionChange,
  disabled,
}: VideoUploadTitleFieldsProps) {
  return (
    <>
      <TextField
        size="small"
        fullWidth
        required
        label="Title for this video"
        helperText="Shown to viewers when the video plays"
        value={title}
        onChange={(event) => onTitleChange(event.target.value)}
        disabled={disabled}
      />
      <TextField
        size="small"
        fullWidth
        required
        multiline
        minRows={2}
        label="Description"
        helperText="Shown to viewers when the video plays"
        value={description}
        onChange={(event) => onDescriptionChange(event.target.value)}
        disabled={disabled}
      />
    </>
  );
}
